import { IntegrationServices } from '@sequencehq/api/utils/commonEnums'
import { useIntegrationsDomainContext } from 'Integrations/communication'
import { useMemo } from 'react'

export const useIntegrationActive = (
  integrationId: IntegrationServices
): boolean => {
  const integrationsContext = useIntegrationsDomainContext()

  const integrationActive = useMemo(() => {
    return Boolean(
      integrationsContext.queries.activeIntegrations.find(
        int => int.id === integrationId
      )?.enabled
    )
  }, [integrationsContext.queries.activeIntegrations, integrationId])

  return integrationActive
}
